import type { DisplayItem, DisplayOrientation, ScheduleSlot } from '../../../components/display/data/types';

// ── Fetch ──────────────────────────────────────────────────────────────────────
export const DISPLAY_FETCH_REQUEST = 'display/FETCH_REQUEST';
export const DISPLAY_FETCH_SUCCESS = 'display/FETCH_SUCCESS';
export const DISPLAY_FETCH_FAILURE = 'display/FETCH_FAILURE';

// ── Real backend — POST /display/template, POST /display/template/{id}, DELETE /display/{id} ──
export const DISPLAY_SAVE_REQUEST = 'display/SAVE_REQUEST';
export const DISPLAY_SAVE_SUCCESS = 'display/SAVE_SUCCESS';
export const DISPLAY_SAVE_FAILURE = 'display/SAVE_FAILURE';
export const DISPLAY_DELETE_REQUEST = 'display/DELETE_REQUEST';

// ── Local-only ────────────────────────────────────────────────────────────────
export const DISPLAY_ITEM_DELETE = 'display/ITEM_DELETE';
export const DISPLAY_SET_EDITING_ID = 'display/SET_EDITING_ID';
export const DISPLAY_TOAST_ADD = 'display/TOAST_ADD';
export const DISPLAY_TOAST_REMOVE = 'display/TOAST_REMOVE';

export interface DisplayToast {
  id: string;
  message: string;
  type: 'success' | 'error' | 'info';
}

export interface Deferred<T = void> {
  resolve: (value: T | PromiseLike<T>) => void;
  reject: (e: Error) => void;
}

export interface DisplayFetchPayload {
  locationId: string;
  search?: string;
}

export interface DisplaySaveRequestPayload {
  /** Present => update an existing display; absent => create. */
  id?: string;
  locationId: string;
  displayName: string;
  mode: 'S' | 'P';
  mediaId?: string;
  playlistId?: string;
  fallbackMediaId: string;
  orientation: DisplayOrientation;
  timeSlots: ScheduleSlot[];
  deferred: Deferred<DisplayItem>;
}

export interface DisplayDeleteRequestPayload {
  id: string;
  locationId: string;
  deferred: Deferred;
}

export interface DisplayState {
  items: DisplayItem[];
  loading: boolean;
  saving: boolean;
  error: string | null;
  loadedLocationId: string | null;
  editingItemId: string | null;
  editingMediaId: string | null;
  toasts: DisplayToast[];
}
